import { render, staticRenderFns } from "./MyCredentialLayout.vue?vue&type=template&id=0ab99e3c&scoped=true&"
import script from "./MyCredentialLayout.vue?vue&type=script&lang=js&"
export * from "./MyCredentialLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab99e3c",
  null
  
)

export default component.exports